/*
  ms-bundle-toggle-anchor.js — Mile Sports: scroll-forankring for "Vis færre" i bundle-lister.

  Problem: "Se flere produkter"/"Vis færre" er en ren CSS checkbox-hack
  (.ms-bundle-more-toggle + .ms-bundle-extra). Ved kollaps forsvinder op mod
  ~2000px indhold øjeblikkeligt, browseren beholder scroll-offset, og brugeren
  "lander" langt nede på siden (fx video-sektionen på PDP).

  Fix: ved klik på "Vis færre" måles knappens viewport-position før kollaps;
  efter reflow scrolles nærmeste scroll-container (eller window) med samme delta,
  så knappen bliver stående hvor den var. Kun ved kollaps — "Se flere" er uændret.

  Additivt lag, rører ikke theme.js. Event-delegation på document → overlever
  section re-renders (cart-drawer). Guard mod dobbelt-inkludering (main-product
  og cart-drawer kan begge inkludere filen på samme side).
*/
(function () {
  if (window.__msBundleToggleAnchor) return;
  window.__msBundleToggleAnchor = true;

  function scrollContainer(el) {
    // body/html ekskluderes: dokument-scroll håndteres via window.scrollBy
    // (body kan have overflow-y:auto + få px "scrollHeight-slæk" uden at være den reelle scroller)
    var p = el.parentElement;
    while (p && p !== document.body && p !== document.documentElement) {
      var s = window.getComputedStyle(p);
      if (/(auto|scroll)/.test(s.overflowY) && p.scrollHeight > p.clientHeight) return p;
      p = p.parentElement;
    }
    return null;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.ms-bundle-more-btn') : null;
    if (!btn) return;
    var input = document.getElementById(btn.htmlFor || btn.getAttribute('for') || '');
    if (!input || !input.checked) return; // kun "Vis færre" (checked -> unchecked)

    var beforeTop = btn.getBoundingClientRect().top;
    // Checkboxens default action (toggle + reflow) sker efter event-dispatch;
    // rAF kører efter den men før næste paint — ingen synligt hop.
    requestAnimationFrame(function () {
      var delta = btn.getBoundingClientRect().top - beforeTop;
      if (!delta) return;
      var container = scrollContainer(btn);
      try {
        (container || window).scrollBy({ top: delta, left: 0, behavior: 'instant' });
      } catch (err) {
        // Ældre browsere uden 'instant' i ScrollOptions
        if (container) container.scrollTop += delta;
        else window.scrollBy(0, delta);
      }
    });
  });
})();
